import { useState } from "react";
import { useSelector } from "react-redux";

import handleNotify from "../utils/helpers/handleNotify.js";
import {
  apiFetchUnsignedDocumentList,
  apiFetchSignedDocumentList,
} from "../api/methods/documents.js";

const useDocuments = () => {
  const { contractInfo } = useSelector(state => state);

  const [contract, setContract] = useState({});
  const [hasError, setHasError] = useState(false);

  /**
   * В массиве signedDocuments в зависимости от типа договора (ФЛ/ЮЛ)
   * будут находиться различные данные (для ФЛ - ранее подписанные документы,
   * для ЮЛ - счета-фактуры)
   */
  const [signedDocuments, setSignedDocuments] = useState([]);
  const [unsignedDocuments, setUnsignedDocuments] = useState([]);

  const [isInitialRender, setIsInitialRender] = useState(true);

  /**
   * В зависимости от типа просматриваемого договора будут запрошены соответствующие документы
   */
  const fetchDocuments = async () => {
    await fetchDocumentsHome();
  };

  /**
   * Получить список документов для ФЛ
   *
   * @param {Object} contract
   */
  const fetchDocumentsHome = async (contract = contractInfo) => {
    try {
      const signedDocuments =
        (await apiFetchSignedDocumentList(contract.contract_id, contract.billing_id)) || [];
      const unsignedDocuments =
        (await apiFetchUnsignedDocumentList(contract.contract_id, contract.billing_id)) || [];

      setSignedDocuments(signedDocuments);
      setUnsignedDocuments(unsignedDocuments);
    } catch (error) {
      handleNotify("error", error);
      setHasError(true);
    }
  };

  return {
    contract,
    setContract,
    signedDocuments,
    unsignedDocuments,
    hasError,
    setHasError,
    fetchDocuments,
    fetchDocumentsHome,
    isInitialRender,
    setIsInitialRender,
  };
};

export default useDocuments;
